import { createFetcher } from "api/helpers"

const fetcherConfiguration = {
  makeRequestUrl: (host) => {
    return `${host}/admin/get_admin_dashboard`
  },
  checkRequiredArguments: () => {},
  makeResponseData: (json) => {
    return json ?? []
  }
}
export default createFetcher(fetcherConfiguration)
